import { useCallback, useEffect, useMemo, useState } from "react";

const CHANNEL_NAME = "3ds-secure-status";

export type ThreeDSecureStatus = "initial" | "pending" | "success" | "error";

export const use3DSecureStatus = (props?: {
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const [status, setStatus] = useState<ThreeDSecureStatus>("initial");

  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    const handler = (event: MessageEvent) => {
      const { status } = event.data;
      setStatus(status);
      if (status === "success") {
        props?.onSuccess?.();
      } else if (status === "error") {
        props?.onError?.();
      }
    };
    channel.addEventListener("message", handler);

    return () => {
      channel.removeEventListener("message", handler);
      channel.close();
    };
  }, [props]);

  const postStatus = useCallback((status: ThreeDSecureStatus) => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage({ status });
    channel.close();
  }, []);

  return useMemo(
    () => ({
      status,
      postStatus,
    }),
    [status, postStatus]
  );
};
